/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Condition
 */
export interface Condition {
    /**
     * The unique identifier of the `Condition`
     * @type {string}
     * @memberof Condition
     */
    id: string;
    /**
     * The type of this `Condition` (URL, GEO, or CHAT)
     * @type {string}
     * @memberof Condition
     */
    conditionType: ConditionConditionTypeEnum;
    /**
     * Whether this condition includes or excludes the matched URLs
     * @type {string}
     * @memberof Condition
     */
    filterType: ConditionFilterTypeEnum;
    /**
     * The matching strategy used to evaluate the condition value
     * @type {string}
     * @memberof Condition
     */
    matchType: ConditionMatchTypeEnum;
    /**
     * The value to match against (e.g. URL path, country code)
     * @type {string}
     * @memberof Condition
     */
    matchValue: string;
}


/**
 * @export
 */
export const ConditionConditionTypeEnum = {
    Url: 'URL',
    Geo: 'GEO',
    Chat: 'CHAT'
} as const;
export type ConditionConditionTypeEnum = typeof ConditionConditionTypeEnum[keyof typeof ConditionConditionTypeEnum];

/**
 * @export
 */
export const ConditionFilterTypeEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE'
} as const;
export type ConditionFilterTypeEnum = typeof ConditionFilterTypeEnum[keyof typeof ConditionFilterTypeEnum];

/**
 * @export
 */
export const ConditionMatchTypeEnum = {
    Simple: 'SIMPLE',
    Exact: 'EXACT',
    Regex: 'REGEX',
    Substring: 'SUBSTRING',
    CountryCode: 'COUNTRY_CODE',
    AgentsAvailable: 'AGENTS_AVAILABLE'
} as const;
export type ConditionMatchTypeEnum = typeof ConditionMatchTypeEnum[keyof typeof ConditionMatchTypeEnum];


/**
 * Check if a given object implements the Condition interface.
 */
export function instanceOfCondition(value: object): value is Condition {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('conditionType' in value) || value['conditionType'] === undefined) return false;
    if (!('filterType' in value) || value['filterType'] === undefined) return false;
    if (!('matchType' in value) || value['matchType'] === undefined) return false;
    if (!('matchValue' in value) || value['matchValue'] === undefined) return false;
    return true;
}

export function ConditionFromJSON(json: any): Condition {
    return ConditionFromJSONTyped(json, false);
}

export function ConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Condition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'conditionType': json['conditionType'],
        'filterType': json['filterType'],
        'matchType': json['matchType'],
        'matchValue': json['matchValue'],
    };
}

export function ConditionToJSON(json: any): Condition {
    return ConditionToJSONTyped(json, false);
}

export function ConditionToJSONTyped(value?: Condition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conditionType': value['conditionType'],
        'filterType': value['filterType'],
        'matchType': value['matchType'],
        'matchValue': value['matchValue'],
    };
}

